import React, { useState, useEffect } from "react";
import { PickList } from "primereact/picklist";
import { Divider } from "primereact/divider";
import { Button } from "primereact/button";
import { useSelector, useDispatch } from 'react-redux';
import { Dialog } from 'primereact/dialog';
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { setTab } from '../../features/job/jobSlice';
import * as jobConstants from "../../enums/jobs";

import {
  fetchFavouritesJobs,
  fetchUserFavouritesJobs,
  addFavouriteJobList,
  setTargetFavouriteList,
  // setSourceFavouriteList,
  setLastUpdateFavourite,
} from './favouritesSlice';

export const FavouritesView = () => {
  const navigate = useNavigate();
  const [discardVisible, setDiscardVisible] = useState(false);
  const [acceptVisible, setAcceptVisible] = useState(false);
  const [source, setSource] = useState([]);
  const jobState = useSelector((state) => state.job);
  const favouritesState = useSelector((state) => state.favourites);
  const {
    userId,
    clientId,
    totalFavoritesRecords,
    favouritesJobList,
    targetFavouriteList,
    userFavouritesJobList,
    lastUpdateFavourite,
  } = favouritesState;
  const {
    appLanguage,
  } = jobState;

  const dispatch = useDispatch();
  useEffect(() => {
    let param = {
      userId: userId,
      clientId: clientId,
    }
    dispatch(fetchFavouritesJobs(param));
    dispatch(fetchUserFavouritesJobs(param));
  }, [dispatch]);

  useEffect(() => {
    let targetFavList = [];
    userFavouritesJobList?.map((e) => {
      targetFavList.push({ 'categoryName': e.jobName });
    });
    dispatch(setTargetFavouriteList(targetFavList));
    let differenceArray = [];
    if (favouritesJobList?.length > 0) {
      differenceArray = favouritesJobList.filter(item1 => !targetFavList.some(item2 => item1.categoryName === item2.categoryName));
    }
    setSource(differenceArray);
  }, [
    favouritesJobList,
    setTargetFavouriteList,
  ]);

  const itemTemplate = (item) => {
    const updateSource = () => {
      let updatedTarget = [];
      let updatedSource = [];
      if (targetFavouriteList.some(el => el.categoryName === item.categoryName)) {
        updatedTarget = targetFavouriteList.filter(el => el.categoryName !== item.categoryName);
        dispatch(setTargetFavouriteList(updatedTarget));
        updatedSource.push(...source, item);
        setSource(updatedSource);
      } else {
        updatedSource = source.filter(el => el.categoryName !== item.categoryName);
        setSource(updatedSource);
        updatedTarget.push(...targetFavouriteList, item);
        dispatch(setTargetFavouriteList(updatedTarget));
      }
    }
    return (
      <div className="picklist-item-wrapper">
        <div className="picklist-item-content">{item.categoryName}</div>
        <span className="picklist-item-icon-wrap" onClick={updateSource}>
          <i className="pi pi-angle-right"></i>
        </span>
      </div>
    );
  };


  const setExitDiscardVisible = () => {
    let param = {
      userId: userId,
      clientId: clientId,
    }
    dispatch(setTargetFavouriteList([]));
    dispatch(fetchFavouritesJobs(param));
    setDiscardVisible(false);
  };

  const setExitAcceptVisible = () => {
    var userFavData = [];
    targetFavouriteList?.map((item) => {
      let objProject = {
        jobNo: 1,
        jobName: item.categoryName,
      };
      userFavData.push(objProject);
    });
    let param = {
      userId: userId,
      clientId: clientId,
      userFavourite: userFavData,
    };
    dispatch(setLastUpdateFavourite(new Date()));
    dispatch(addFavouriteJobList(param)).then((response) => {
      if (response?.payload?.status === 200) {
        dispatch(fetchUserFavouritesJobs({ userId: userId, clientId: clientId }));
        setAcceptVisible(false);
        dispatch(setTab(jobConstants.TABS.FAVOURITES));
        setTimeout(() => {
        navigate("/")
        }, 1000);
      } else {
        // handle error or show a message
      }
    });
  };

  const discardFooterContent = (
    <div>
      <Button label={appLanguage["preferences.btn.cancel"]} onClick={() => setDiscardVisible(false)} className="p-button-text" />
      <Button label={appLanguage["preferences.btn.exit"]} onClick={() => setExitDiscardVisible()} autoFocus />
    </div>
  );

  const acceptFooterContent = (
    <div>
      <Button label={appLanguage["preferences.btn.cancel"]} onClick={() => setAcceptVisible(false)} className="p-button-text" />
      <Button label={appLanguage["preferences.btn.save-exit"]} onClick={() => setExitAcceptVisible(false)} autoFocus />
    </div>
  );

  const discardUserFavList = () => {
    setDiscardVisible(true);
  }

  const acceptUserFavList = () => {
    setAcceptVisible(true);
  }

  return (
    <div className="favourites-wrapper">
      <div className="favourites-wrapper-inner">
        {/* left col start */}
        <div className="left-col-outer box-border">
          <div className="w-100">
            <div className="card">
              <PickList
                source={source}
                target={targetFavouriteList}
                itemTemplate={itemTemplate}
                filter
                filterBy="categoryName"
                sourceHeader={appLanguage["preferences.label.joblist"]}
                targetHeader={appLanguage["preferences.label.myfavourites"]}
                sourceFilterPlaceholder={appLanguage["preferences.label.placeholder.searchjob"]}
                targetFilterPlaceholder={appLanguage["preferences.label.placeholder.searchjob"]}
              // style={{height:'499px'}}
              />
            </div>
          </div>
        </div>
        {/* left col end */}

        {/* right col start */}
        <div className="right-col-outer box-border">
          <div className="box-border">
            <div className="w-100">
              <div className="right-col-left">
                {/* <h3>{appLanguage["preferences.label.information"]}</h3> */}
                <div className="favourites-info-box">{appLanguage["preferences.label.information"]}</div>
                <p>{appLanguage["preferences.label.total-job-available"]}: {totalFavoritesRecords}</p>
                <p>{appLanguage["preferences.label.no-of-favourite-jobs"]}: {targetFavouriteList.length}</p>
                <div className="last-update-box">
                  <p>
                    {appLanguage["preferences.label.last-update"]}:
                    <br />
                    {/* 16 Oct 2023 13:15 */}
                    {lastUpdateFavourite
                      ? moment(lastUpdateFavourite).format("DD MMM YYYY-HH:mm")
                      : userFavouritesJobList
                        ? moment(userFavouritesJobList?.[0]?.updatedAt).format(
                          "DD MMM YYYY-HH:mm"
                        )
                        : ""}
                  </p>
                </div>
                <div className="btn-wrapper">
                  <div className="card flex justify-content-center">
                    <Dialog
                      className="favouritePopup"
                      visible={discardVisible}
                      onHide={() => setDiscardVisible(false)}
                      footer={discardFooterContent}
                    >
                      <p className="m-0">{appLanguage["preferences.label.leave-savng-changes"]}</p>
                    </Dialog>
                    <Dialog
                      className="favouritePopup"
                      visible={acceptVisible}
                      onHide={() => setVisible(false)}
                      footer={acceptFooterContent}
                    >
                      <p className="m-0">{appLanguage["preferences.label.save-and-exit"]}</p>
                    </Dialog>
                  </div>
                  {/* <ConfirmPopup /> */}
                  <Button
                    label={appLanguage["preferences.btn.cancel-changes-and-exit"]}
                    severity="secondary"
                    onClick={discardUserFavList}
                  />
                  <Button
                    label={appLanguage["preferences.btn.save-changes-and-exit"]}
                    severity="danger"
                    onClick={acceptUserFavList}
                    // disabled={targetFavouriteList.length === 0 ? true : false}
                  />
                </div>
              </div>
              <Divider layout="vertical" />
              <div className="right-col-right">
                {/* <h3>{appLanguage["preferences.label.instruction"]}</h3> */}
                <div className="favourites-info-box">{appLanguage["preferences.label.instruction"]}</div>
                {/* <p>{appLanguage["preferences.label.instruction_description"]}</p> */}
                <p>{appLanguage["preferences.label.instruction_description1"]}</p>
                <p>{appLanguage["preferences.label.instruction_description2"]}</p>
                <p>{appLanguage["preferences.label.instruction_description3"]}</p>
              </div>
            </div>
          </div>
        </div>
        {/* right col end */}
      </div>
      {/* <hr class="footer-border" /> */}
    </div>
  );
};
